import dayjs from 'dayjs'

export const DATE_FORMAT_API = 'YYYY/MM/DD'
export const FRONT_DATE_FORMAT = 'DD.MM.YYYY'
export const EUDONET_DATE_FORMAT = 'YYYY/MM/DD HH:mm:ss'
export const morningEndTime = dayjs().set('hours', 12).set('minutes', 30)
export const afternoonEndTime = dayjs().set('hours', 18).set('minutes', 0)

export const CALENDAR_DATE_FORMAT = 'YYYY-MM-DD'
